import moment from 'moment-timezone';
import { KPI_CONFIG } from './KPIMapping';

export const INSTANCES = [
    { key: 0, text: 'ami-01f18be4e32df20e2', value: 'ami-01f18be4e32df20e2' },
    { key: 1, text: 'ami-09988af04120b3591', value: 'ami-09988af04120b3591' },
    { key: 2, text: 'c6id.4xlarge', value: 'c6id.4xlarge' },
    { key: 3, text: 'g4dn.2xlarge', value: 'g4dn.2xlarge' },
    { key: 4, text: 'i-05dddffb6ddcb5d97', value: 'i-05dddffb6ddcb5d97' },
    { key: 5, text: 'i-066f763a0bffdf424', value: 'i-066f763a0bffdf424' }
];

export const REGIONS = [
    { key: 0, text: 'us-east-1', value: 'us-east-1' },
    { key: 1, text: 'us-east-2', value: 'us-east-2' },
    { key: 2, text: 'us-west-1', value: 'us-west-1' },
    { key: 3, text: 'us-west-2', value: 'us-west-2' }
];

export const EC2_AWS_METRICS = [
    { key: 'CPUUTILIZATION', text: 'CPU utilization', value: 'CPUUTILIZATION' },
    { key: 'METADATANOTOKEN', text: 'METADATANOTOKEN', value: 'METADATANOTOKEN' },
    { key: 'DISKREADOPS', text: 'DISKREADOPS', value: 'DISKREADOPS' },
    { key: 'DISKWRITEOPS', text: 'DISKWRITEOPS', value: 'DISKWRITEOPS' },
    { key: 'DISKREADBYTES', text: 'DISKREADBYTES', value: 'DISKREADBYTES' },
    { key: 'DISKWRITEBYTES', text: 'DISKWRITEBYTES', value: 'DISKWRITEBYTES' },
    { key: 'NETWORKIN', text: 'NETWORKIN', value: 'NETWORKIN' },
    { key: 'NETWORKOUT', text: 'NETWORKOUT', value: 'NETWORKOUT' },
    { key: 'NETWORKPACKETSIN', text: 'NETWORKPACKETSIN', value: 'NETWORKPACKETSIN' },
    { key: 'NETWORKPACKETSOUT', text: 'NETWORKPACKETSOUT', value: 'NETWORKPACKETSOUT' },
    { key: 'EBSREADOPS', text: 'EBSREADOPS', value: 'EBSREADOPS' },
    { key: 'EBSWRITEOPS', text: 'EBSWRITEOPS', value: 'EBSWRITEOPS' },
    { key: 'EBSREADBYTES', text: 'EBSREADBYTES', value: 'EBSREADBYTES' },
    { key: 'EBSWRITEBYTES', text: 'EBSWRITEBYTES', value: 'EBSWRITEBYTES' },
    { key: 'EBSBYTEBALANCE%', text: 'EBSBYTEBALANCE%', value: 'EBSBYTEBALANCE%' },
    { key: 'EBSIOBALANCE%', text: 'EBSIOBALANCE%', value: 'EBSIOBALANCE%' }
];

export const OUTPOST_AWS_METRICS = [
    { key: 'CONNECTEDSTATUS', text: 'CONNECTEDSTATUS', value: 'CONNECTEDSTATUS' },
    { key: 'INSTANCEFAMILYCAPACITYAVAILABILITY', text: 'INSTANCEFAMILYCAPACITYAVAILABILITY', value: 'INSTANCEFAMILYCAPACITYAVAILABILITY' },
    { key: 'AVAILABLEINSTANCETYPECOUNT', text: 'AVAILABLEINSTANCETYPECOUNT', value: 'AVAILABLEINSTANCETYPECOUNT' },
    { key: 'USEDINSTANCETYPECOUNT', text: 'USEDINSTANCETYPECOUNT', value: 'USEDINSTANCETYPECOUNT' },
    { key: 'EBSVOLUMETYPECAPACITYUTILIZATION', text: 'EBSVOLUMETYPECAPACITYUTILIZATION', value: 'EBSVOLUMETYPECAPACITYUTILIZATION' },
    { key: 'EBSVOLUMETYPECAPACITYAVAILABILITY', text: 'EBSVOLUMETYPECAPACITYAVAILABILITY', value: 'EBSVOLUMETYPECAPACITYAVAILABILITY' },
    { key: 'EBSVOLUMETYPECAPACITYUTILIZATIONGB', text: 'EBSVOLUMETYPECAPACITYUTILIZATIONGB', value: 'EBSVOLUMETYPECAPACITYUTILIZATIONGB' },
    { key: 'EBSVOLUMETYPECAPACITYAVAILABILITYGB', text: 'EBSVOLUMETYPECAPACITYAVAILABILITYGB', value: 'EBSVOLUMETYPECAPACITYAVAILABILITYGB' },
    { key: 'CAPACITYEXCEPTIONS', text: 'CAPACITYEXCEPTIONS', value: 'CAPACITYEXCEPTIONS' }
];

export const S3_AWS_METRICS = [
    { key: 'BUCKETSIZEBYTES', text: 'BUCKETSIZEBYTES', value: 'BUCKETSIZEBYTES' },
    { key: 'NUMBEROFOBJECTS', text: 'NUMBEROFOBJECTS', value: 'NUMBEROFOBJECTS' }
];

export const EBS_AWS_METRICS = [
    { key: 'VOLUMEREADBYTES', text: 'VOLUMEREADBYTES', value: 'VOLUMEREADBYTES' },
    { key: 'VOLUMEWRITEBYTES', text: 'VOLUMEWRITEBYTES', value: 'VOLUMEWRITEBYTES' }
];

export const KPI_RESPONSE = [
    {
        metricData: {},
        metricDataMap: null,
        label: 'FIRSTBYTELATENCY',
        unit: 'firstbytelatency',
        dimension: {
            name: 'BucketName',
            value: 'aws-cloudtrail-logs-832403491045-299a8ab4'
        },
        instanceId: 'aws-cloudtrail-logs-832403491045-299a8ab4'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'FIRSTBYTELATENCY',
        unit: 'firstbytelatency',
        dimension: {
            name: 'FilterId',
            value: 'olga-request-related-metrics'
        },
        instanceId: 'olga-request-related-metrics'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BYTESUPLOADED',
        unit: 'bytesuploaded',
        dimension: {
            name: 'BucketName',
            value: 'aws-cloudtrail-logs-832403491045-299a8ab4'
        },
        instanceId: 'aws-cloudtrail-logs-832403491045-299a8ab4'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BYTESUPLOADED',
        unit: 'bytesuploaded',
        dimension: {
            name: 'FilterId',
            value: 'olga-request-related-metrics'
        },
        instanceId: 'olga-request-related-metrics'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'outpost-euless-autoscallingtmp.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'outpost-br-vpc-bucket.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'vzmmp2-outpost-server-launch-test'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'outpost-rac-br1-eksclu.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'outpost-rac-br-eksclu.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'vzmmp2-outpost-amitest'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'outpost-euless-ubuntu.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'br-vpc-flows'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'aws-cloudtrail-logs-832403491045-6326db92'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'outpost-instances-ubuntu.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'outpost-instances-statefile.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'management-statefile.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'aws-cloudtrail-logs-832403491045-6eab0f3e'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'lakshmiawsbucket'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'aws-cloudtrail-logs-832403491045-299a8ab4'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'outpost-rac.mmp2.poc.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'cf-templates-qx8yio6zgv9a-us-east-1'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'outpost-instances-statefile.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'aws-cloudtrail-logs-832403491045-299a8ab4'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'mec-tf-state-bucket'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'vz-mp08-np-pmec-poc-ct'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'testdatadogbucket'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'management-statefile.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'outpost.mmp2.poc.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'outpost-euless-vpc.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'aws-cloudtrail-logs-832403491045-7ecc92a3'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'br-tr-outpost.vpc-flowlogs'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'aws-cloudtrail-logs-832403491045-f2665efd'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'outpost-58c78.mmp2.poc.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'outpost-rac-autoscallingtmp.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'aws-cloudtrail-logs-832403491045-ab62c7af'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'br-tr-outpost.vpc-flowlogs'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'cf-templates-qx8yio6zgv9a-us-east-1'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'outpost-br-vpc-bucket.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'outpost-rac-autoscallingtmp.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'outpost-rac-br-eksclu.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'outpost-rac-br-eks.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'outpost-rac.mmp2.poc.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'outpost-euless-vpc-bucket.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'testdatadogbucket'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'pmec.mmp31.isveu2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'mmp2pmec.mmp2.isveu2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'aws-cloudtrail-logs-832403491045-ab62c7af'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'outpost-eu-vpc-bucket.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'vzmmp2-outpost-server-launch-test'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'outpost-rac-linux.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'aws-cloudtrail-logs-832403491045-f2665efd'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'TOTALREQUESTLATENCY',
        unit: 'totalrequestlatency',
        dimension: {
            name: 'BucketName',
            value: 'aws-cloudtrail-logs-832403491045-299a8ab4'
        },
        instanceId: 'aws-cloudtrail-logs-832403491045-299a8ab4'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'TOTALREQUESTLATENCY',
        unit: 'totalrequestlatency',
        dimension: {
            name: 'FilterId',
            value: 'olga-request-related-metrics'
        },
        instanceId: 'olga-request-related-metrics'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'ALLREQUESTS',
        unit: 'allrequests',
        dimension: {
            name: 'BucketName',
            value: 'aws-cloudtrail-logs-832403491045-299a8ab4'
        },
        instanceId: 'aws-cloudtrail-logs-832403491045-299a8ab4'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'ALLREQUESTS',
        unit: 'allrequests',
        dimension: {
            name: 'FilterId',
            value: 'olga-request-related-metrics'
        },
        instanceId: 'olga-request-related-metrics'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'PUTREQUESTS',
        unit: 'putrequests',
        dimension: {
            name: 'BucketName',
            value: 'aws-cloudtrail-logs-832403491045-299a8ab4'
        },
        instanceId: 'aws-cloudtrail-logs-832403491045-299a8ab4'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'PUTREQUESTS',
        unit: 'putrequests',
        dimension: {
            name: 'FilterId',
            value: 'olga-request-related-metrics'
        },
        instanceId: 'olga-request-related-metrics'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'LISTREQUESTS',
        unit: 'listrequests',
        dimension: {
            name: 'BucketName',
            value: 'aws-cloudtrail-logs-832403491045-299a8ab4'
        },
        instanceId: 'aws-cloudtrail-logs-832403491045-299a8ab4'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'LISTREQUESTS',
        unit: 'listrequests',
        dimension: {
            name: 'FilterId',
            value: 'olga-request-related-metrics'
        },
        instanceId: 'olga-request-related-metrics'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BYTESDOWNLOADED',
        unit: 'bytesdownloaded',
        dimension: {
            name: 'BucketName',
            value: 'aws-cloudtrail-logs-832403491045-299a8ab4'
        },
        instanceId: 'aws-cloudtrail-logs-832403491045-299a8ab4'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BYTESDOWNLOADED',
        unit: 'bytesdownloaded',
        dimension: {
            name: 'FilterId',
            value: 'olga-request-related-metrics'
        },
        instanceId: 'olga-request-related-metrics'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'outpost-rac-eu-eksclu.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'aws-cloudtrail-logs-832403491045-6326db92'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'eu-tr-outpost.vpc-flowlogs'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'aws-cloudtrail-logs-832403491045-be046dfc'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'aws-cloudtrail-logs-832403491045-7ecc92a3'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'outpost-rac-eu-eksclusterscript.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'outpost-rac-autoscalling.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'br-vpc-flows'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'outpost-rac-eu-eksclusterscript.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'br-outpost-srv.vpc-flowlog'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'managment-runner-instances-test.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'aws-cloudtrail-logs-832403491045-be046dfc'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'outpost-euless-ubuntu.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'outpost-58c78.mmp2.poc.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'outpost-rac-autoscalling.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'mmp2pmec.mmp2.isveu2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'lakshmiawsbucket'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'euless-outpost-s3-aws-cloudtrail-logs-832403491045-b662dae6'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'outpost-euless-vpc-bucket.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'mec-tf-state-bucket'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'outpost-eu-vpc-bucket.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'outpost-rac-br-eks.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'outpost-euless-autoscallingtmp.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'br-outpost-srv.vpc-flowlog'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'managment-runner-instances-test.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'euless-outpost-s3-aws-cloudtrail-logs-832403491045-b662dae6'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'outpost-rac-linux.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'pmec.mmp31.isveu2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'aws-cloudtrail-logs-832403491045-6eab0f3e'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'outpost-rac-br1-eksclu.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'vz-mp08-np-pmec-poc-ct'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'outpost.mmp2.poc.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'BUCKETSIZEBYTES',
        unit: 'standardstorage',
        dimension: {
            name: 'StorageType',
            value: 'StandardStorage'
        },
        instanceId: 'outpost-instances-ubuntu.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'eu-tr-outpost.vpc-flowlogs'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'outpost-rac-eu-eksclu.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'outpost-euless-vpc.mmp2.terraform.state'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'HEADREQUESTS',
        unit: 'headrequests',
        dimension: {
            name: 'BucketName',
            value: 'aws-cloudtrail-logs-832403491045-299a8ab4'
        },
        instanceId: 'aws-cloudtrail-logs-832403491045-299a8ab4'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'HEADREQUESTS',
        unit: 'headrequests',
        dimension: {
            name: 'FilterId',
            value: 'olga-request-related-metrics'
        },
        instanceId: 'olga-request-related-metrics'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: '4XXERRORS',
        unit: 'a4xxerrors',
        dimension: {
            name: 'BucketName',
            value: 'aws-cloudtrail-logs-832403491045-299a8ab4'
        },
        instanceId: 'aws-cloudtrail-logs-832403491045-299a8ab4'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: '4XXERRORS',
        unit: 'a4xxerrors',
        dimension: {
            name: 'FilterId',
            value: 'olga-request-related-metrics'
        },
        instanceId: 'olga-request-related-metrics'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: 'NUMBEROFOBJECTS',
        unit: 'allstoragetypes',
        dimension: {
            name: 'StorageType',
            value: 'AllStorageTypes'
        },
        instanceId: 'vzmmp2-outpost-amitest'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: '5XXERRORS',
        unit: 'a5xxerrors',
        dimension: {
            name: 'BucketName',
            value: 'aws-cloudtrail-logs-832403491045-299a8ab4'
        },
        instanceId: 'aws-cloudtrail-logs-832403491045-299a8ab4'
    },
    {
        metricData: {},
        metricDataMap: null,
        label: '5XXERRORS',
        unit: 'a5xxerrors',
        dimension: {
            name: 'FilterId',
            value: 'olga-request-related-metrics'
        },
        instanceId: 'olga-request-related-metrics'
    }
];

const generateRandomValue = (kpiName) => {
    switch (kpiName) {
        case 'CPUUTILIZATION':
            // CPU utilization typically ranges from 0 to 100 percent
            return Math.random() * 100;
        case 'NETWORKOUT':
            // Network out can vary widely, but let's assume a range from 50,000 to 150,000 bytes
            return 50000 + Math.random() * 100000;
        case 'NETWORKIN':
            // Network in can also vary, assume a range from 30,000 to 120,000 bytes
            return 30000 + Math.random() * 90000;
        default:
            return Math.random() * 100;
    }
};

export const generateKpiResponse = (count) => {
    const kpiResponse = [];

    const kpis = Object.keys(KPI_CONFIG);

    INSTANCES.map((instance) => instance.value).forEach((instance) => {
        kpis.forEach((kpiName) => {
            const metricData = [];
            for (let i = 0; i < count; i++) {
                metricData.push({
                    timeStamp: moment().subtract(i, 'minutes').valueOf().toString(),
                    value: generateRandomValue(kpiName)
                });
            }

            kpiResponse.push({
                metricData: {
                    [kpiName]: metricData
                },
                metricDataMap: null,
                label: kpiName,
                unit: kpiName === 'CPUUTILIZATION' ? 'Percent' : 'Byte',
                instanceId: instance
            });
        });
    });

    return kpiResponse;
};
